import { Currency } from '../currency/currency';
import { useGetOrderTotalQuery } from './orders.api';

export const OrderTotal = (props: { id: string }) => {
  const { data, isLoading } = useGetOrderTotalQuery(props.id);
  if (isLoading) {
    return <span>loading...</span>;
  }
  return <Currency value={data?.total ?? 0} />;
};
